'use client';

import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { DashboardTitleBar } from '../layout/DashboardTitleBar';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ViewListIcon from '@mui/icons-material/ViewList';
import InventoryAuditorDashboardCharts from '../inventory-auditor/InventoryAuditorDashboardCharts';
import InventoryAuditorRecentCountReportsSection from '../inventory-auditor/InventoryAuditorRecentCountReportsSection';

const InventoryAuditorDashboardPage: React.FC = () => {
  const { user } = useAuth();
  const unitName = user?.currentBusinessUnit?.name;
  return (
    <Box>
      <DashboardTitleBar unitName={unitName} />
      <Box sx={{ p: 3, pt: 0 }}>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Full-store inventory counts: pick a location, scan UPCs, set counted quantities, and apply.
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <Button
            component={RouterLink}
            to="/app/inventory-auditor/locations"
            variant="contained"
            startIcon={<LocationOnIcon />}
            sx={{ textTransform: 'none', alignSelf: 'flex-start' }}
          >
            Locations
          </Button>
          <Button
            component={RouterLink}
            to="/app/inventory-auditor/site-visit"
            variant="outlined"
            startIcon={<FactCheckIcon />}
            sx={{ textTransform: 'none', alignSelf: 'flex-start' }}
          >
            Full store count
          </Button>
          <Button
            component={RouterLink}
            to="/app/inventory-auditor/catalog"
            variant="outlined"
            startIcon={<ViewListIcon />}
            sx={{ textTransform: 'none', alignSelf: 'flex-start' }}
          >
            Item catalog
          </Button>
        </Stack>

        <InventoryAuditorRecentCountReportsSection />

        <Box sx={{ mt: 4 }}>
          <InventoryAuditorDashboardCharts />
        </Box>
      </Box>
    </Box>
  );
};

export default InventoryAuditorDashboardPage;
